export const chunkPairs = <T>(items: T[]): T[][] => {
	const pairs: T[][] = [];
	for (let i = 0; i < items.length; i += 2) {
		pairs.push(items.slice(i, i + 2));
	}
	return pairs;
};
